<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_search_placeholder')"
            />

            <b-input-group-append>
              <b-button
                variant="link"
                size="sm"
                class="search-dropdown-button"
                squared
                @click="openAdvqueryDialog"
              >
                {{ $l('INDEX.advanced_search') || '高级搜索' }}
              </b-button>

              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-input-group-append>

            <b-button
              v-if="allow('A')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('add')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      show-close
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_batchSize') || '批量范围'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-input-number
                    v-model="form.batchMinSize"
                    :placeholder="
                      $l('form_placeholder_batchMinSize') ||
                        '请输入批量范围最小值'
                    "
                    :min="0"
                    :step="1"
                    :precision="0"
                    step-strictly
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.batchMaxSize"
                    :placeholder="
                      $l('form_placeholder_batchMaxSize') ||
                        '请输入批量范围最大值'
                    "
                    :min="0"
                    :step="1"
                    :precision="0"
                    step-strictly
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_inspectionLevel') || '检验水平'"
            >
              <el-input
                v-model.trim="form.inspectionLevel"
                :placeholder="
                  $l('form_placeholder_inspectionLevel') || '请输入检验水平'
                "
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_sampleSize') || '抽样数量'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-input-number
                    v-model="form.sampleSizeStart"
                    :placeholder="
                      $l('form_placeholder_sampleSizeStart') || '请输入抽样数量'
                    "
                    :min="0"
                    :step="1"
                    :precision="0"
                    step-strictly
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.sampleSizeEnd"
                    :placeholder="
                      $l('form_placeholder_sampleSizeEnd') || '请输入抽样数量'
                    "
                    :min="0"
                    :step="1"
                    :precision="0"
                    step-strictly
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_acceptanceNum') || '合格判定数'"
            >
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-input-number
                    v-model="form.acceptanceNumStart"
                    :placeholder="
                      $l('form_placeholder_acceptanceNumStart') ||
                        '请输入合格判定数'
                    "
                    :min="0"
                    :step="1"
                    :precision="0"
                    step-strictly
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.acceptanceNumEnd"
                    :placeholder="
                      $l('form_placeholder_acceptanceNumEnd') ||
                        '请输入合格判定数'
                    "
                    :min="0"
                    :step="1"
                    :precision="0"
                    step-strictly
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_createBy') || '创建人'">
              <dict-select
                v-model="form.listCreateBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_createBy') || '请选择创建人'"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
              <dict-select
                v-model="form.listModifyBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_modifyBy') || '请选择修改人'"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_createTime') || '创建时间'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    :placeholder="
                      $l('form_placeholder_createTimeStart') || '请选择创建时间'
                    "
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    :placeholder="
                      $l('form_placeholder_createTimeEnd') || '请选择创建时间'
                    "
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_modifyTime') || '修改时间'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    :placeholder="
                      $l('form_placeholder_modifyTimeStart') || '请选择修改时间'
                    "
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    :placeholder="
                      $l('form_placeholder_modifyTimeEnd') || '请选择修改时间'
                    "
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}

.line {
  text-align: center;
}
</style>
